<template>
  <div
    class="order-detail"
    data-cy="order-detail"
  >
    <div class="order-detail__header">
      <button
        class="order-detail__back-button btn-link"
        data-cy="order-detail-back"
        @click="onBack"
      >
        <i class="fa fa-arrow-left" />&nbsp;
        <span
          v-t="'BACK'"
          class="order-detail__back-label text-uppercase"
        />
      </button>
      <span
        v-if="!statusPending"
        class="timestamp"
      >{{ getDate(order.startTime) }}</span>
    </div>
    <div v-if="!statusPending">
      <h3 class="order-detail__title">
        {{ $t('ORDER') }} {{ order.id }}
      </h3>
      <div class="order-detail__body">
        <p>
          {{ $t('ORDER_STATUS') }} 
          <span
            class="order-detail__status"
            :class="orderStatusColor"
          >{{ orderStatus }}</span>
        </p>
        <p v-if="order.errorMessage">
          {{ $t('ORDER_ERROR_MESSAGE') }} {{ order.errorMessage }}
        </p>
        <p>{{ $t('ORDER_COUNTRY') }} {{ order.assigmentSettings.countryCode }}</p>
        <p v-if="order.assigmentSettings.areaCode">
          {{ $t('ORDER_AREA_CODE') }} {{ order.assigmentSettings.areaCode }}
        </p>
        <p v-if="order.affiliateId"> 
          {{ $t('ORDER_PUBLISHER') }}                     
          <a
            rel="noopener"
            target="_blank"
            href="javascript:;"
            class="table-ellipsis__name linked-name"
            @click.prevent="gotToPublisher(order.affiliateId)"
          >
            <span
              class="display-text"
              :title="order.publisher.name"
            >
              {{ order.publisher.name }}
            </span>
          </a>
        </p>
        <p>{{ $t('ORDER_NUMBER_TYPE') }} {{ order.assigmentSettings.isTollFree ? $t('NUMBER_TF'): $t('NUMBER_DID') }}</p>
        <p>{{ $t('ORDER_AMOUNT') }} {{ order.requestAmount }}</p>
        <p>{{ $t('ORDER_CHARGE') }} {{ $t(order.chargeAccountToFill? 'YES': 'NO') }}</p>
        <p> {{ $t('ORDER_ALLOCATED') }} {{ order.completedAmount }}</p>
      </div>
      <div class="text-right p-t-5">
        <button
          v-if="!order.completed"
          class="btn btn-danger"
          data-cy="order-detail-cancel"
          @click="cancelOrder"
        >
          {{ $t('ORDER_CANCEL') }}
        </button>
      </div>
    </div>
    <div v-if="statusPending">
      <Loader />
      <span v-t="'ORDER_LOADING'" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Loader from '@/core/components/Loader';
import { STATUS_PENDING } from '@/store/helpers';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  components: { Loader },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      }
    },
    status: {
      type: Object,
      default() {
        return {};
      }
    },
    timezone: {
      type: String,
      default: 'America/Los_Angeles',
    }
  },
  computed: {
    orderStatus() {
      if (!this.order.completed) {
        return 'Pending';
      } 
      if (this.order.canceledByUser) {
        return 'Canceled';
      }
      if(this.order.errorCode >= 0) {
        return 'Canceled (System)';
      }
      return 'Completed';
    },
    orderStatusColor() {
      if (!this.order.completed) {
        return 'text-warning';
      } 
      if (this.order.canceledByUser || (this.order.errorCode >= 0)) {
        return 'text-danger';
      }
      return '';
    },
    statusPending() {
      return this.status.status == STATUS_PENDING;
    }
  },
  methods: {
    onBack() {
      this.$emit('back');
    },
    cancelOrder() {
      this.$emit('cancelOrder', this.order.id);
    },
    getDate(timeStamp) {
      return moment(timeStamp).tz(this.timezone).format('MMM DD hh:mm:ss A');
    },
    gotToPublisher(affiliateId) {
      $ngStateService.go('dashboard.affiliate.edit', {
        affiliateId
      });
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss" scoped>
.order-detail {
  flex: 1;
  padding: 12px 20px 20px 20px;
  background-color: var(--component-in-app-notifications__message-detail);
  color: var(--component-in-app-notifications__message-detail-font-color);

  a {
    color: var(
      --component-in-app-notifications__message-detail-font-link-color
    );
  }

  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-weight: 300;
    color: var(
      --component-in-app-notifications__message-detail-header-font-color
    );

    .order-detail__back-button {
      color: var(
        --component-in-app-notifications__message-detail-header__link-font-color
      );
      cursor: pointer;
      border: 0;
      .order-detail__back-label:hover {
        text-decoration: underline;
      }
    }
  }
  &__title {
    line-height: 1.5;
    font-size: 14px;
    margin-bottom: 15px;
    word-break: break-word;
  }
  &__body {
    line-height: 1.7;
    max-height: 40.5vh;
    font-size: 12px;
    overflow-y: auto;
  }
}
</style>